import logger from '../../utils/logger';

export const INVESTMENT_TYPE_LABELS = {
  bank_balance: 'Bank Balance', fixed_deposit: 'Fixed Deposit', mutual_fund: 'Mutual Fund',
  treasury_bill: 'Treasury Bill', quoted_stocks: 'Quoted Stocks', government_bond: 'Government Bond',
  corporate_bond: 'Corporate Bond', private_equity: 'Private Equity', convertible: 'Convertible',
  safe: 'SAFE Investment', crypto: 'Cryptocurrency', real_estate: 'Real Estate', etf: 'ETF', gold: 'Gold',
};

export const TYPE_COLORS = {
  quoted_stocks: 'bg-blue-100 text-blue-800 border-blue-200',
  crypto: 'bg-orange-100 text-orange-800 border-orange-200',
  mutual_fund: 'bg-green-100 text-green-800 border-green-200',
  government_bond: 'bg-indigo-100 text-indigo-800 border-indigo-200',
  corporate_bond: 'bg-purple-100 text-purple-800 border-purple-200',
  bank_balance: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  fixed_deposit: 'bg-teal-100 text-teal-800 border-teal-200',
  private_equity: 'bg-rose-100 text-rose-800 border-rose-200',
  convertible: 'bg-amber-100 text-amber-800 border-amber-200',
  safe: 'bg-cyan-100 text-cyan-800 border-cyan-200',
  treasury_bill: 'bg-slate-100 text-slate-800 border-slate-200',
  real_estate: 'bg-pink-100 text-pink-800 border-pink-200',
  etf: 'bg-sky-100 text-sky-800 border-sky-200',
  gold: 'bg-yellow-100 text-yellow-800 border-yellow-200',
};

export const formatTableCurrency = (amount, currency = 'USD') => {
  try {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(amount);
  } catch (err) {
    logger.error(err);
    return `${currency} ${new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(amount)}`;
  }
};

export const formatTableDate = (dateString) => {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
};
